import React, { memo, useCallback, useEffect, useMemo } from "react";
import SelectInput from "../common/SelectInput";
import { useDispatch, useSelector } from "react-redux";
import { return_parcels_v2 } from "../../helpers/OrdersFunctionsGlobal";
import { setCountriesOptions, setParcelTerminalsOptions } from "../../redux/Actions/options_action";
import PropTypes from 'prop-types';


function SelectParcelTerminalInput({ label, value, shipment_type, delivery, country_id, onChange, error: initialError }) {
    console.count('SelectParcelTerminalInput')
    const dispatch = useDispatch()
    const { countries, parcel_terminals } = useSelector((state) => state.options);

    useEffect(() => {
        dispatch(setCountriesOptions());
        dispatch(setParcelTerminalsOptions());
    }, [])

    const country = useMemo(() => {
        if (!country_id) return null;
        return countries.find(c => c.id === country_id);
    }, [country_id, countries])

    const options = useMemo(() => {
        if (!country) return [];
        return return_parcels_v2(
            parcel_terminals,
            shipment_type,
            delivery,
            country.code
        );
    }, [parcel_terminals, shipment_type, delivery, country]);

    const error = useMemo(() => {
        if (!!initialError) return initialError
        if (!country) return 'Not selected country'
        if (options.length == 0) return "Empty list of parcel terminals"
        return null;
    }, [options, country, initialError])

    // console.log({ options, error })

    const onChangeCallBack = useCallback((value) => {
        onChange(value)
    }, [])

    return (
        <div>
            <SelectInput
                required={true}
                label={label}
                options={options}
                value={value || undefined}
                onChange={onChangeCallBack}
                error={error}
            />
        </div>
    );
}

export default memo(SelectParcelTerminalInput);

SelectParcelTerminalInput.propTypes = {
    label: PropTypes.string,
    value: PropTypes.number,
    shipment_type: PropTypes.string.isRequired,
    delivery: PropTypes.string.isRequired,
    country_id: PropTypes.number,
    onChange: PropTypes.func.isRequired
};